/**
 * Convert Firestore Timestamp, seconds-based object, ISO string, or Date to a JS Date.
 * Plain `{ seconds, nanoseconds }` / `{ _seconds, _nanoseconds }` objects (e.g. from merged
 * snapshots) are coerced; otherwise `.toLocaleString()` on the object yields "[object Object]".
 * @param {*} value
 * @returns {Date | null}
 */
export function normalizeFirestoreDate(value) {
  if (value == null) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value.toDate === "function") {
    try {
      const d = value.toDate();
      return Number.isNaN(d.getTime()) ? null : d;
    } catch {
      return null;
    }
  }
  if (typeof value === "object") {
    const sec =
      typeof value.seconds === "number"
        ? value.seconds
        : typeof value._seconds === "number"
          ? value._seconds
          : null;
    if (sec != null) {
      const nano =
        typeof value.nanoseconds === "number"
          ? value.nanoseconds
          : typeof value._nanoseconds === "number"
            ? value._nanoseconds
            : 0;
      const d = new Date(sec * 1000 + nano / 1e6);
      return Number.isNaN(d.getTime()) ? null : d;
    }
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof value === "string") {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}
